module.exports = __webpack_public_path__ + "static/media/adult-education.d1ba8535.jpg";